import { Reference } from '@sanity/types';
import imageUrlBuilder from '@sanity/image-url';

import { ParentCategory } from 'lib/sanity/types';
import { Vertical, getVerticalConfig } from 'utils/vertical';

export const emptyChildCategoriesFilter = ({ childCategories }: ParentCategory): boolean => childCategories.length > 0;

export const urlForImage = ({
  source,
  maxWidth,
  vertical,
}: {
  source: Reference;
  maxWidth: number;
  vertical: Vertical;
}): string => {
  return imageUrlBuilder({ clientConfig: getVerticalConfig(vertical).cms })
    .image(source)
    .auto('format')
    .width(maxWidth)
    .fit('max')
    .url();
};
